import { StateService } from "@uirouter/angularjs";
import { IFieldArray, ITemplateScope } from "AngularFormly";
import { FormViewController } from "../../../../records/forms/formView/controller";
import { Record } from "../../../../records/server/crud";
import { IHasResponseStatus } from "../../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";

const apiUrl = "/api/machines/progressives/ProgressiveMeterReadingSetting";

export class ProgressiveMeterReadingSettingsEditViewController {
  static $inject = [ServerUtilityName, "$state"];

  readonly formFields: IFieldArray;
  readonly progressiveMeterReadingSetting: Record = {
    Id: 0,
    MeterReadingRequired: true,
    EveryXDays: 1,
  };

  constructor(
    private readonly serverUtility: ServerUtility,
    private readonly $state: StateService
  ) {
    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          {
            key: "Name",
            name: "Name",
            type: "input",
            templateOptions: {
              required: true,
              label: "Name",
            },
            asyncValidators: {
              unique: (
                $viewValue: any,
                $modelValue: any,
                scope: ITemplateScope
              ) => {
                const id = scope.model?.Id;
                return serverUtility
                  .alreadyExists({
                    url: apiUrl,
                    query: { Name: $viewValue },
                    excludeId: id,
                  })
                  .then((alreadyTaken) => {
                    if (alreadyTaken) {
                      throw new Error();
                    }
                  });
              },
            },
          },
          fieldHelpers.simpleBoolField({
            key: "MeterReadingRequired",
            name: "MeterReadingRequired",
            label: "Meter Reading Required",
          }),
          {
            key: "ComparisonField",
            name: "ComparisonField",
            type: "select",
            templateOptions: {
              label: "Comparison Field",
              options: [
                {
                  label: "Level Reading",
                  value: "LevelReading",
                },
                {
                  label: "Reset Base",
                  value: "ResetBase",
                },
              ],
              required: true,
              labelProp: "label",
              valueProp: "value",
            },
          },
          fieldHelpers.simpleNumberField({
            key: "ComparisonValue",
            name: "ComparisonValue",
            label: "Comparison Value",
            min: 0,
            required: false,
          }),
          fieldHelpers.simpleNumberField({
            key: "AllReadingsRequiredDayOfMonth",
            name: "AllReadingsRequiredDayOfMonth",
            label: "All Readings Required Day Of Month",
            min: -28,
            max: 28,
          }),
        ],
        4
      ),
    ];
  }

  submit(formViewController: FormViewController) {
    return this.serverUtility
      .post({
        url: apiUrl,
        postObject: this.progressiveMeterReadingSetting,
      })
      .then(() => {
        this.$state.go("^");
      })
      .catch((error) => {
        const apiResponse = <IHasResponseStatus>error.data;
        formViewController.setApiErrors(apiResponse.ResponseStatus);
      });
  }

  cancel() {
    return this.$state.go("^");
  }
}
